import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  AdminDocumentJob,
  AdminDocumentJobDetail,
  DocumentJobCompany,
  DocumentJobFilters,
  PaginatedResponse,
  PaginationParams,
} from 'src/app/admin/models/document-job.model';

@Injectable({ providedIn: 'root' })
export class DocumentJobAdminService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/admin/document-jobs`;

  listJobs(
    filters: DocumentJobFilters = {},
    pagination: PaginationParams = { page: 1, limit: 20 },
  ): Observable<PaginatedResponse<AdminDocumentJob>> {
    let params = new HttpParams()
      .set('page', pagination.page.toString())
      .set('limit', pagination.limit.toString());

    if (filters.status) params = params.set('status', filters.status);
    if (filters.type) params = params.set('type', filters.type);
    if (filters.companyId) params = params.set('companyId', filters.companyId);

    return this.http.get<PaginatedResponse<AdminDocumentJob>>(this.apiUrl, { params });
  }

  getJob(id: string): Observable<{ data: AdminDocumentJobDetail }> {
    return this.http.get<{ data: AdminDocumentJobDetail }>(`${this.apiUrl}/${id}`);
  }

  listCompanies(): Observable<{ data: DocumentJobCompany[] }> {
    return this.http.get<{ data: DocumentJobCompany[] }>(`${this.apiUrl}/companies`);
  }
}
